// meta.ts — Endpoints info applicative (version + changelog).
import { req } from './_internals.js';

export const metaApi = {
  getVersion: () => req('GET', '/version'),
  getChangelog: () => req('GET', '/changelog'),
};
